import { Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledWrapper = styled(Box)(({ theme }) => ({
  // marginTop: '120px',
  minWidth: '320px',
  border: '1px solid rgba(255,255,255,0.15)',
  background: theme.palette.bg.secondary,
  borderRadius: '8px',
  padding: theme.spacing(2),
  height: '566px',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('lg')]: {
    width: '100%',
    marginTop: theme.spacing(2),
    // order: 1,
  },
  [theme.breakpoints.down('md')]: {
    height: '320px',
  },
}));
export const TableTotalWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  background: theme.palette.bg.main,
  padding: theme.spacing(1),
  [theme.breakpoints.down('lg')]: {
    marginTop: theme.spacing(2),
  },
}));

export const CustomTypography = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  '& > svg:first-of-type': {
    marginRight: theme.spacing(1),
  },
  '& > svg:last-of-type': {
    marginLeft: theme.spacing(1),
  },
  [theme.breakpoints.down('sm')]: {
    '&>span': {
      marginRight: '4px',
    },
  },
}));

interface ExpandedWrapperProps {
  isExpanded?: boolean;
}

export const ExpandedWrapper = styled('div')<ExpandedWrapperProps>(
  ({ theme, isExpanded }) => ({
    // height: isExpanded ? '755px' : '0px',
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    transition: 'height 0.3s ease-in-out',
    borderRadius: theme.spacing(1),
    '& .MuiPaper-root>div': {
      padding: theme.spacing(1),
      backgroundColor: '#16161b!important',
    },
    '& .MuiTableCell-root': {
      backgroundColor: '#16161b!important',
      borderBottom: 'none!important',
      padding: '0!important',
    },
    '& td,& th': {
      padding: 0,
      paddingRight: theme.spacing(1),
      height: '24px',
      background: '#16161b',
    },
    '& thead td': {
      color: 'rgba(255,255,255,0.45)',
    },
    '& td:last-child,& th:last-child': {
      paddingRight: 0,
    },
  }),
);

export const StyledUserItem = styled('span')<any>(({ theme }) => ({
  display: 'inline-flex',
  '.MuiTypography-root': {
    width: '70px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    // textOverflow: 'ellipsis',
  },
  '&>span': {
    marginLeft: '2px',
  },
}));
export const StyledProfitItem = styled('span')<any>(
  ({ theme, green = false }) => ({
    display: 'inline-flex',
    '&>span': {
      marginRight: '4px',
      color: green ? theme.palette.green[500] : theme.palette.grey[50],
    },
  }),
);
